module.exports = __webpack_public_path__ + "static/media/purecard.2928f28f.png";